import { Layout, Panel, } from "@mcleod/components";

export abstract class AutogenLayoutDemoScreenFlowSample extends Layout {
    layout1: Layout;
    outerPanel: Panel;
}
